import { useGoogleMap } from '@react-google-maps/api';
import { useCallback, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { format, fromUnixTime } from 'date-fns';

const getTimestamps = async (): Promise<number[]> => {
  const data = await fetch('https://api.rainviewer.com/public/maps.json');
  return data.json();
};

const useTimestamps = () => {
  return useQuery('timestamps', getTimestamps, {
    refetchInterval: 600000, // 60000(1min) * 10
  });
};

export const useRain = () => {
  const map = useGoogleMap();

  const { data } = useTimestamps();

  const [isShow, setIsShow] = useState(true);

  useEffect(() => {
    if (map && data) {
      const latestTimestamp = data ? data[data.length - 1] : undefined;

      map.overlayMapTypes.clear();

      const rainTiles = new google.maps.ImageMapType({
        name: '雨',
        getTileUrl: (coord, zoom) =>
          `https://tilecache.rainviewer.com/v2/radar/${latestTimestamp}/256/${zoom}/${coord.x}/${coord.y}/2/1_1.png`,
        tileSize: new google.maps.Size(256, 256),
      });

      map.overlayMapTypes.push(rainTiles);
    }
  }, [data, map]);

  useEffect(() => {
    if (map && data) {
      const rainTiles = map.overlayMapTypes.getAt(0) as
        | google.maps.ImageMapType
        | undefined;

      rainTiles?.setOpacity(isShow ? 0.5 : 0);
    }
  }, [isShow, map, data]);

  const toggleRain = useCallback(() => {
    setIsShow((p) => !p);
  }, []);

  const time = data
    ? format(fromUnixTime(data[data.length - 1]), 'yy/MM/dd HH:mm')
    : '読み込み中';

  return { toggleRain, isShow, time };
};
